// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
export enum ViewAllType {
	PROJECT = 'project',
	ISSUE = 'issue',
	BOARD = 'board',
	FILTER = 'filter',
	PLAN = 'plan',
}

export const getViewAllUrl = (type: ViewAllType, search?: string) => {
	switch (type) {
		case ViewAllType.ISSUE:
			return `/jira/search${search ? `?searchString=${search}` : ''}`;
		case ViewAllType.BOARD:
			return `/jira/boards${search ? `?contains=${search}` : ''}`;
		case ViewAllType.PROJECT:
			return `/jira/projects${search ? `?keyword=${search}` : ''}`;
		case ViewAllType.FILTER:
			return `/jira/filters${search ? `?name=${search}` : ''}`;
		case ViewAllType.PLAN:
			return `/jira/plans${search ? `?name=${search}` : ''}`;
		default:
			return undefined;
	}
};
